import {NgModule} from '@angular/core'
import {ExtraOptions, RouterModule, Routes} from '@angular/router'
import {AuthComponent} from './auth/auth.component'
import {AuthenticationGuard} from './auth/authentication.guard'

const routes: Routes = [
  {path: 'auth', component: AuthComponent, loadChildren: () => import('app/auth/auth.module').then(m => m.AuthModule)},
  {path: 'app', loadChildren: () => import('../app/pages/pages.module').then(m => m.PagesModule), canActivate: [AuthenticationGuard]},
  {path: '', redirectTo: 'app', pathMatch: 'full'},
  {path: '**', redirectTo: 'app'}
]

const config: ExtraOptions = {useHash: false, anchorScrolling: 'enabled'}

@NgModule({
  imports: [RouterModule.forRoot(routes, config)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
